import { api as real } from './real';
import { api as mock } from './mock';

/* Один флаг переключает приложение между заглушками и живым бэкендом.
   Дев по умолчанию на заглушках (.env.development), боевая сборка — на API. */
export const USING_MOCKS = import.meta.env.VITE_USE_MOCKS === 'true';

export const api = USING_MOCKS ? mock : real;
export { ApiError } from './http';
